import { acceptOnlyValidOptionByLabel } from '../../field-viewer/shared-normalizers';
export const radioGroupViewer = {
    normalizeLoadedValue: acceptOnlyValidOptionByLabel
};

//# sourceMappingURL=definition-viewer.js.map